import { Badge } from "../../../../../components/ui/common/badge";

interface FacilityDetailsHeaderProps {
  facilityTypeLabel: string;
  facilityOwnershipLabel: string;
}

const FacilityDetailsHeader = ({ facilityTypeLabel, facilityOwnershipLabel }: FacilityDetailsHeaderProps) => (
  <div className="tw-flex tw-items-center tw-gap-2 tw-mt-1">
    <Badge variant="outline" className="tw-text-[10px] tw-font-mono">
      {facilityTypeLabel}
    </Badge>
    <Badge variant="outline" className="tw-text-[10px] tw-font-normal">
      {facilityOwnershipLabel}
    </Badge>
  </div>
);

export default FacilityDetailsHeader;
